import type { ThirdPartyPlugin } from '../types';
import type { QP } from './types';
import { setup, load } from './script';

declare global {
  interface Window {
    /**
     * @description Quora Pixel plugin
     * @see [quora pixel](https://www.quora.com/ads/pixel)
     */
    qp: QP;
  }
}

const options = {
  id: '2704b35a59734537a5f9243d2c444e94',
};

const quoraPlugin: ThirdPartyPlugin = () => {
  setup(options);

  return {
    entry: window.qp,
    // TODO: must be implemented if we want to load quora pixel as promise
    load: () => {
      load(options);
      return Promise.resolve();
    },
  };
};

export default quoraPlugin;
